import React, { useEffect, useState } from 'react'
import DatePicker from 'react-datepicker2'
import * as momentJalaali from 'moment-jalaali';


const CustomDatePicker = (props) => {

  const [value, setValue] = useState(props.value ? momentJalaali(props.value): undefined)

  // console.log(value)
  // console.log(momentJalaali(props.value))

  useEffect(() => {
    // setValue(momentJalaali(new Date(props.value)))
  }, [props.value])

  return (
    <div>
      <DatePicker
        timePicker={false}
        persianDigits={false}
        isGregorian={false}
        value={value}
        onChange={(e) => { props.onChange(new Date(e._d).toLocaleDateString()) }}
      />
    </div>
  )
}

export default CustomDatePicker